import { SettingDefinition } from '@120wateraudit/envirio-components/dist/models'
import CrudActions, { ICrudActions } from 'src/actions/helpers/CrudActions'

const actions: ICrudActions = CrudActions<SettingDefinition>({
  entityName: 'definition',
  collectionName: 'definitons'
})

export default actions
